import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARklEQVR42mWKSQoAIRAD/f/X5jwg+AEPtidFRbvjAqJgIJClFC5JDRAu99TUeRnJfsj0z/ICwg2JNLI3C36BMZbohmnlDXSC333vCSYWAgAAAABJRU5ErkJggg=="};
